'use client';

import { c as _c } from "react/compiler-runtime";
import MuiBreadcrumbs from '@mui/material/Breadcrumbs';
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Link } from 'src/components/Atoms/Link';
interface BreadcrumbsProps {
  items: string[];
}
const StyledBreadcrumbs = styled(MuiBreadcrumbs)(({
  theme
}) => ({
  '&.MuiBreadcrumbs-root': {
    padding: `${theme.sizes.spacing.none}`,
    minHeight: theme.sizes.spacing['08']
  },
  '& .MuiBreadcrumbs-ol': {
    padding: 0,
    margin: 0,
    listStyle: 'none'
  },
  '& .MuiBreadcrumbs-separator': {
    color: theme.colors.text.disabled,
    fontSize: theme.fonts.size.base,
    fontFamily: theme.fonts.family.body,
    fontWeight: theme.fonts.weight.normal,
    lineHeight: theme.fonts.lineHeight['leading-6'],
    letterSpacing: theme.fonts.letterSpacing.normal
  },
  '& .MuiBreadcrumbs-li': {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '& .MuiTypography-root': {
      // TODO: Implement body-sm variant instead of styled typography
      color: theme.colors.text.link,
      fontSize: theme.fonts.size.sm,
      fontFamily: theme.fonts.family.body,
      fontWeight: theme.fonts.weight.normal,
      lineHeight: theme.fonts.lineHeight['leading-5'],
      letterSpacing: theme.fonts.letterSpacing.wide,
      whiteSpace: 'nowrap',
      wordWrap: 'none',
      textOverflow: 'ellipsis'
    },
    '&:last-child .MuiTypography-root': {
      color: theme.colors.text.disabled
    }
  }
}));
const CrumbItem: React.FC<{
  label: string;
  href?: string;
}> = t0 => {
  const $ = _c(3);
  const {
    label,
    href
  } = t0;
  let t1;
  if ($[0] !== href || $[1] !== label) {
    t1 = href ? <Link href={href}><Typography variant="body2" component="span">{label}</Typography></Link> : <Typography variant="body2">{label}</Typography>;
    $[0] = href;
    $[1] = label;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
const Breadcrumbs: React.FC<BreadcrumbsProps> = t0 => {
  const $ = _c(6);
  const {
    items: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const items = t2;
  let t3;
  if ($[2] !== items) {
    t3 = items.map(_temp);
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <StyledBreadcrumbs>{t3}</StyledBreadcrumbs>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default Breadcrumbs;
export type { BreadcrumbsProps };
export const dynamic = 'force-dynamic';
function _temp(item, index) {
  return <CrumbItem label={item} key={`${item}-${index}`} />;
}